export default __webpack_public_path__ + "static/screenshot_5d-e69e48830784bdd8fb602605038b2e17.png";